// IE 2026 10 08 / ODOO-5800 (поручение Игоря, скрин dev02 стол 2W1_001, окно zRY_001 из чипса: у строки «Поточне» отмечены И «Всі», И «Я»,
// хотя «Я» на zRY_001 никто не ставил — «давай не будем показывать "Я" здесь и в других похожих выборах, если нет явного выбора»).
// Причина: отметка строки ОСНОВНОЙ считалась как «цель не назначена → основная открывается сама» (Widget.vue settingsList_rebuild,
// AttrChips.vue строки «(main)» фильтров/страницы) — для «Я» это выглядело как личный выбор пользователя, которого нет.
// Теперь колонка «Я» отмечает ТОЛЬКО явную цель пользователя (settings_defaults / default_*_me); «Всі» — как было (строка основной ☑ при пустой цели).
// Выключатель fe.ux.meMarkExplicitOnly (по умолчанию вкл.; window.feSettings.set('fe.ux.meMarkExplicitOnly', false) — прежнее поведение).
// Чистые функции без DOM/store — tests/unit/settingsDefaultMarks.test.mjs.

/** Отметка колонки All/Me у строки rowId: target — назначенная цель (id), mainId — строка основной настройки.
 *  explicitOnly=false (колонка «Всі», прежнее «Я»): цель пуста → ☑ у основной («открывается сама»); цель есть → ☑ у цели.
 *  explicitOnly=true (колонка «Я»): ☑ только у явно назначенной цели; пусто — нигде. */
export function defaultMark(rowId, mainId, target, explicitOnly = false) {
    const t = target || ''
    if (t) return !!rowId && rowId === t
    if (explicitOnly) return false
    return !!rowId && rowId === mainId
}

/** Читает выключатель из store (store.setting), без store — включено. */
export function meMarkExplicitOnly(store) {
    try { return store?.setting?.('fe.ux.meMarkExplicitOnly', true) !== false } catch (e) { return true }
}
